import { render, staticRenderFns } from "./CustomerQuotesList.vue?vue&type=template&id=1059badc&scoped=true&"
import script from "./CustomerQuotesList.vue?vue&type=script&lang=js&"
export * from "./CustomerQuotesList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerQuotesList.vue?vue&type=style&index=0&id=1059badc&lang=scss&scoped=true&"
import style1 from "./CustomerQuotesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1059badc",
  null
  
)

export default component.exports